import { c as _c } from "react/compiler-runtime";
import { HiOutlineShare } from 'react-icons/hi2';
import { Button } from '@/components';
type Props = {
  title: string;
  text: string;
  url: string;
};
export const Share = t0 => {
  const $ = _c(7);
  const {
    title,
    text,
    url
  } = t0;
  let t1;
  if ($[0] !== text || $[1] !== title || $[2] !== url) {
    t1 = () => {
      navigator.share({
        title,
        text,
        url
      });
    };
    $[0] = text;
    $[1] = title;
    $[2] = url;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleShare = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HiOutlineShare className="size-4" aria-hidden="true" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleShare) {
    t3 = <Button type="button" variant="outline" onClick={handleShare} aria-label="Share this page">{t2}Share</Button>;
    $[5] = handleShare;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};